// Same cap as the product list upload (MAX_PRODUCTS_LIMIT).
export const MAX_MENTIONS_LIMIT = 5000;

// Taxonomy ids are 32-bit signed integers: a larger value cannot be a mention
// id, so it is reported as invalid instead of being sent to the API.
export const MAX_MENTION_ID = 2147483647;

export const MAX_DISPLAYED_INVALID_IDS = 10;

// Same columns as the Mention Name / Mention ID fields of a Mentions export.
export const MENTION_CSV_HEADERS = ["mention_name", "mention_id"];

// Header only: example rows would import real mentions if left in the file.
export const MENTION_CSV_TEMPLATE = `${MENTION_CSV_HEADERS.join(",")}\n`;
